export default __webpack_public_path__ + "static/media/res4.b2aa1d22.PNG";